import { render } from "./submission-panel-affiliate.vue?vue&type=template&id=848d63a8&scoped=true&ts=true"
import script from "./submission-panel-affiliate.vue?vue&type=script&lang=ts"
export * from "./submission-panel-affiliate.vue?vue&type=script&lang=ts"

import "./submission-panel-affiliate.vue?vue&type=style&index=0&id=848d63a8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-848d63a8"]])

export default __exports__